'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var groupPackagesForUI = require('./groupPackagesForUI.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var SessionContext = require('../../providers/SessionContext.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionContext = /*#__PURE__*/React__default["default"].createContext(null);
const usePackageSelection = () => {
  const context = React.useContext(PackageSelectionContext);
  if (!context) {
    throw new Error('No context provided for PackageSelection provider');
  }
  return context;
};
const PackageSelectionProvider = _ref => {
  let {
    children,
    value: {
      shipments,
      packageClaims
    }
  } = _ref;
  const {
    state: {
      claimType
    },
    handlePackageClaimSelection
  } = index.useClaimBuilder();
  const logEvent = useAnalytics["default"]();
  const titan = useTitanAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    selectedShipments,
    eligibleShipments,
    ineligibleShipments
  } = groupPackagesForUI.groupPackagesForUI(shipments, packageClaims);
  const handlePackageSelection = shipment => {
    var _shipment$edd;
    titan === null || titan === void 0 ? void 0 : titan.track({
      event: 'product_clicked',
      properties: {
        product_id: shipment.trackingNumber,
        sku: shipment.items.map(item => item.sku).join(','),
        brand: shipment.status,
        variant: shipment.statusCode,
        name: (_shipment$edd = shipment.edd) === null || _shipment$edd === void 0 ? void 0 : _shipment$edd.begin
      }
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ITEM_SELECTED,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
      page_step: useAnalytics.ClaimsPageStep.SELECTION,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handlePackageClaimSelection({
      packageId: shipment.id
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(PackageSelectionContext.Provider, {
    value: {
      selectedShipments,
      eligibleShipments,
      ineligibleShipments,
      packageClaims,
      handlePackageSelection
    }
  }, children);
};

exports.PackageSelectionContext = PackageSelectionContext;
exports.PackageSelectionProvider = PackageSelectionProvider;
exports.usePackageSelection = usePackageSelection;
